/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PatchedUserUpdateProfileRequest } from '../model';
// @ts-ignore
import { SellerInfoCreate } from '../model';
// @ts-ignore
import { SellerInfoCreateRequest } from '../model';
// @ts-ignore
import { User } from '../model';
// @ts-ignore
import { UserWithOrgMemberships } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes the user from the system, making their account inactive
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerDeleteDestroy: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user profile details
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdateProfileRequest} [patchedUserUpdateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerProfilePartialUpdate: async (aaSource?: string, patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserUpdateProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the users profile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerProfileRetrieve: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the sellers info details, returning the created data
         * @summary Create/Update the sellers info
         * @param {SellerInfoCreateRequest} sellerInfoCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerSellerInfoCreate: async (sellerInfoCreateRequest: SellerInfoCreateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sellerInfoCreateRequest' is not null or undefined
            assertParamExists('sellerSellerInfoCreate', 'sellerInfoCreateRequest', sellerInfoCreateRequest)
            const localVarPath = `/v2/seller/seller-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sellerInfoCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the user from the system, making their account inactive
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDestroy: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user profile details
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdateProfileRequest} [patchedUserUpdateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPartialUpdate: async (aaSource?: string, patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserUpdateProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the users profile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRetrieve: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes the user from the system, making their account inactive
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerDeleteDestroy(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerDeleteDestroy(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user profile details
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdateProfileRequest} [patchedUserUpdateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerProfilePartialUpdate(aaSource?: string, patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithOrgMemberships>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerProfilePartialUpdate(aaSource, patchedUserUpdateProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the users profile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerProfileRetrieve(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithOrgMemberships>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerProfileRetrieve(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the sellers info details, returning the created data
         * @summary Create/Update the sellers info
         * @param {SellerInfoCreateRequest} sellerInfoCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerSellerInfoCreate(sellerInfoCreateRequest: SellerInfoCreateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerInfoCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerSellerInfoCreate(sellerInfoCreateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes the user from the system, making their account inactive
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDestroy(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userDestroy(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user profile details
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdateProfileRequest} [patchedUserUpdateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPartialUpdate(aaSource?: string, patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPartialUpdate(aaSource, patchedUserUpdateProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the users profile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRetrieve(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRetrieve(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes the user from the system, making their account inactive
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerDeleteDestroy(aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.sellerDeleteDestroy(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user profile details
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdateProfileRequest} [patchedUserUpdateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerProfilePartialUpdate(aaSource?: string, patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest, options?: any): AxiosPromise<UserWithOrgMemberships> {
            return localVarFp.sellerProfilePartialUpdate(aaSource, patchedUserUpdateProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the users profile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerProfileRetrieve(aaSource?: string, options?: any): AxiosPromise<UserWithOrgMemberships> {
            return localVarFp.sellerProfileRetrieve(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the sellers info details, returning the created data
         * @summary Create/Update the sellers info
         * @param {SellerInfoCreateRequest} sellerInfoCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerSellerInfoCreate(sellerInfoCreateRequest: SellerInfoCreateRequest, aaSource?: string, options?: any): AxiosPromise<SellerInfoCreate> {
            return localVarFp.sellerSellerInfoCreate(sellerInfoCreateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes the user from the system, making their account inactive
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDestroy(aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userDestroy(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user profile details
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedUserUpdateProfileRequest} [patchedUserUpdateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPartialUpdate(aaSource?: string, patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest, options?: any): AxiosPromise<User> {
            return localVarFp.userPartialUpdate(aaSource, patchedUserUpdateProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the users profile
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRetrieve(aaSource?: string, options?: any): AxiosPromise<User> {
            return localVarFp.userRetrieve(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerDeleteDestroy operation in UserApi.
 * @export
 * @interface UserApiSellerDeleteDestroyRequest
 */
export interface UserApiSellerDeleteDestroyRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiSellerDeleteDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerProfilePartialUpdate operation in UserApi.
 * @export
 * @interface UserApiSellerProfilePartialUpdateRequest
 */
export interface UserApiSellerProfilePartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiSellerProfilePartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedUserUpdateProfileRequest}
     * @memberof UserApiSellerProfilePartialUpdate
     */
    readonly patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest
}

/**
 * Request parameters for sellerProfileRetrieve operation in UserApi.
 * @export
 * @interface UserApiSellerProfileRetrieveRequest
 */
export interface UserApiSellerProfileRetrieveRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiSellerProfileRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerSellerInfoCreate operation in UserApi.
 * @export
 * @interface UserApiSellerSellerInfoCreateRequest
 */
export interface UserApiSellerSellerInfoCreateRequest {
    /**
     * 
     * @type {SellerInfoCreateRequest}
     * @memberof UserApiSellerSellerInfoCreate
     */
    readonly sellerInfoCreateRequest: SellerInfoCreateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiSellerSellerInfoCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userDestroy operation in UserApi.
 * @export
 * @interface UserApiUserDestroyRequest
 */
export interface UserApiUserDestroyRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiUserDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for userPartialUpdate operation in UserApi.
 * @export
 * @interface UserApiUserPartialUpdateRequest
 */
export interface UserApiUserPartialUpdateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiUserPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedUserUpdateProfileRequest}
     * @memberof UserApiUserPartialUpdate
     */
    readonly patchedUserUpdateProfileRequest?: PatchedUserUpdateProfileRequest
}

/**
 * Request parameters for userRetrieve operation in UserApi.
 * @export
 * @interface UserApiUserRetrieveRequest
 */
export interface UserApiUserRetrieveRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserApiUserRetrieve
     */
    readonly aaSource?: string
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Deletes the user from the system, making their account inactive
     * @param {UserApiSellerDeleteDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sellerDeleteDestroy(requestParameters: UserApiSellerDeleteDestroyRequest = {}, options?: any) {
        return UserApiFp(this.configuration).sellerDeleteDestroy(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user profile details
     * @param {UserApiSellerProfilePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sellerProfilePartialUpdate(requestParameters: UserApiSellerProfilePartialUpdateRequest = {}, options?: any) {
        return UserApiFp(this.configuration).sellerProfilePartialUpdate(requestParameters.aaSource, requestParameters.patchedUserUpdateProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the users profile
     * @param {UserApiSellerProfileRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sellerProfileRetrieve(requestParameters: UserApiSellerProfileRetrieveRequest = {}, options?: any) {
        return UserApiFp(this.configuration).sellerProfileRetrieve(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the sellers info details, returning the created data
     * @summary Create/Update the sellers info
     * @param {UserApiSellerSellerInfoCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sellerSellerInfoCreate(requestParameters: UserApiSellerSellerInfoCreateRequest, options?: any) {
        return UserApiFp(this.configuration).sellerSellerInfoCreate(requestParameters.sellerInfoCreateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes the user from the system, making their account inactive
     * @param {UserApiUserDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userDestroy(requestParameters: UserApiUserDestroyRequest = {}, options?: any) {
        return UserApiFp(this.configuration).userDestroy(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user profile details
     * @param {UserApiUserPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userPartialUpdate(requestParameters: UserApiUserPartialUpdateRequest = {}, options?: any) {
        return UserApiFp(this.configuration).userPartialUpdate(requestParameters.aaSource, requestParameters.patchedUserUpdateProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the users profile
     * @param {UserApiUserRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userRetrieve(requestParameters: UserApiUserRetrieveRequest = {}, options?: any) {
        return UserApiFp(this.configuration).userRetrieve(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
